var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgR = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "5.25rem",
  height: "5.25rem",
  "data-name": "Group 38",
  viewBox: "0 0 165.813 209.094"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "R_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h165.813v209.094H0z",
  "data-name": "Rectangle 33",
  style: {
    fill: "none"
  }
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 37",
  style: {
    clipPath: "url(#R_svg__a)"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M73.021 60.162c-8.3 0-19.607-8.474-27.491-20.607-8.336-12.829-5.313-30.616-3.93-36.7 6.123 1.2 23.6 5.667 31.941 18.5 9.988 15.371 12.012 32.524 4.419 37.458a8.9 8.9 0 0 1-4.943 1.353",
  "data-name": "Path 118",
  style: {
    fill: "#fff"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M43.542 5.821c7.1 1.672 20.948 6.184 27.908 16.892 9.765 15.029 10.774 30.346 5.152 34a6.47 6.47 0 0 1-3.581.949c-6.138 0-16.7-6.093-25.4-19.469C40.7 27.534 42.195 13 43.542 5.821M39.75 0s-7.25 24.1 3.683 40.917c8.678 13.353 20.594 21.745 29.588 21.745a11.38 11.38 0 0 0 6.3-1.757c8.893-5.779 7.244-24.1-3.685-40.917S39.75 0 39.75 0",
  "data-name": "Path 119"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M82.926 87.058a4 4 0 0 1-3.977-3.615c-1.4-14.44 3.273-43.655 30.965-50.867a4 4 0 1 1 2.017 7.742c-22.468 5.851-26.19 30.263-25.019 42.355a4 4 0 0 1-3.6 4.366 4 4 0 0 1-.391.019",
  "data-name": "Path 120"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M82.9 203.446c-3.009.223-10.431 1.337-16.047 4.011-7.021 3.344-20.393 1.672-30.088-6.017S4.675 172.02.329 123.545c-2.675-26.411 10.7-68.534 50.815-70.874a93 93 0 0 1 17.862 2.077c4.9.918 9.4 1.761 13.9 1.6l.006.011v-.011c4.5.161 8.993-.682 13.9-1.6a93 93 0 0 1 17.861-2.077c40.117 2.34 53.489 44.463 50.815 70.874-4.346 48.475-26.746 70.205-36.44 77.9s-23.067 9.361-30.088 6.017c-5.617-2.674-13.039-3.788-16.047-4.011v-.012z",
  "data-name": "Path 121"
})), /*#__PURE__*/React.createElement("path", {
  d: "M39.267 73.183a10.455 10.455 0 1 1-10.455 10.455 10.455 10.455 0 0 1 10.455-10.455",
  "data-name": "Path 122",
  style: {
    fill: "#fff"
  }
})));
export default SvgR;